(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-benefits"] && !Shopify.designMode) return;
  try {
    
(function() {
  var track = document.querySelector('[data-benefits-track]');
  var prevBtn = document.querySelector('[data-benefits-prev]');
  var nextBtn = document.querySelector('[data-benefits-next]');
  var dotsWrap = document.querySelector('[data-benefits-dots]');
  if (!track || !prevBtn || !nextBtn) return;

  var cards = track.children;
  var cardWidth = 300 + 20;

  /* Build dots */
  if (dotsWrap && cards.length > 0) {
    for (var i = 0; i < cards.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cl-benefits__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Scroll to benefit ' + (i + 1));
      dot.dataset.idx = i;
      dotsWrap.appendChild(dot);
    }
    dotsWrap.addEventListener('click', function(e) {
      var d = e.target.closest('.cl-benefits__dot');
      if (!d) return;
      var idx = parseInt(d.dataset.idx, 10);
      var card = cards[idx];
      if (card) track.scrollTo({ left: card.offsetLeft - 16, behavior: 'smooth' });
    });
  }

  function updateControls() {
    prevBtn.hidden = track.scrollLeft <= 10;
    nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;

    var fadeLeft = document.querySelector('.cl-benefits__fade--left');
    if (fadeLeft) fadeLeft.style.opacity = track.scrollLeft > 10 ? '1' : '0';
    var fadeRight = document.querySelector('.cl-benefits__fade--right');
    if (fadeRight) fadeRight.style.opacity = (track.scrollLeft + track.clientWidth < track.scrollWidth - 10) ? '1' : '0';

    /* Update active dot based on scroll position */
    if (dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.cl-benefits__dot');
      var closestIdx = 0;
      var closestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs(cards[i].offsetLeft - track.scrollLeft - 16);
        if (dist < closestDist) { closestDist = dist; closestIdx = i; }
      }
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === closestIdx); });
    }
  }

  prevBtn.addEventListener('click', function() {
    track.scrollBy({ left: -cardWidth * 2, behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function() {
    track.scrollBy({ left: cardWidth * 2, behavior: 'smooth' });
  });

  /* Reset scroll to start on load — prevents browser scroll restoration */
  track.scrollLeft = 0;

  track.addEventListener('scroll', updateControls, { passive: true });
  updateControls();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var hero = document.getElementById('collection-hero');
  if (!hero) return;
  var img = hero.querySelector('.cl-hero__img');
  if (!img) return;

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        var progress = -rect.top / (rect.height + window.innerHeight);
        var shift = progress * 80; /* max 80px shift — strong parallax */
        img.style.transform = 'translateY(' + shift + 'px)';
      }
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo-content"] && !Shopify.designMode) return;
  try {
    
(function() {
  var wrap = document.querySelector('[data-seo-wrap]');
  var content = document.querySelector('[data-seo-content]');
  var fade = document.querySelector('[data-seo-fade]');
  var toggle = document.querySelector('[data-seo-toggle]');
  var toggleText = document.querySelector('[data-seo-toggle-text]');
  if (!wrap || !content || !toggle) return;

  var text = content.textContent || '';
  if (text.length < 600) return; /* Only show read more for 600+ chars */

  wrap.classList.add('is-collapsed');
  fade.hidden = false;
  toggle.hidden = false;

  toggle.addEventListener('click', function() {
    wrap.classList.toggle('is-collapsed');
    var nowCollapsed = wrap.classList.contains('is-collapsed');
    if (toggleText) toggleText.textContent = nowCollapsed ? 'Read More' : 'Read Less';
    toggle.classList.toggle('is-expanded', !nowCollapsed);
    fade.hidden = !nowCollapsed;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sticky = document.querySelector('[data-sticky-cta]');
  if (!sticky) return;
  var subcats = document.getElementById('subcategories');
  var footer = document.querySelector('.footer-wrapper, footer');
  if (!subcats) return;

  function check() {
    var subBottom = subcats.getBoundingClientRect().bottom;
    var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    var show = subBottom < 0 && footerTop > window.innerHeight;
    sticky.hidden = false;
    sticky.classList.toggle('is-visible', show);
  }

  window.addEventListener('scroll', check, { passive: true });
  check();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-subcategories"] && !Shopify.designMode) return;
  try {
    
/* ── Filter Drawer toggle ── */
(function() {
  var toggle = document.querySelector('[data-filter-toggle]');
  var drawer = document.querySelector('[data-filter-drawer]');
  if (!toggle || !drawer) return;

  function open() {
    drawer.hidden = false;
    requestAnimationFrame(function() { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function() { drawer.hidden = true; }, 300);
  }

  toggle.addEventListener('click', open);
  drawer.querySelectorAll('[data-filter-close]').forEach(function(el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* Apply filters — build URL from checked inputs */
  var applyBtn = drawer.querySelector('[data-filter-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      var params = [];
      drawer.querySelectorAll('.cl-filter-drawer__checkbox:checked').forEach(function(cb) {
        params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
      });
      drawer.querySelectorAll('.cl-filter-drawer__price-input').forEach(function(input) {
        if (input.value) {
          params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
        }
      });
      var base = window.location.pathname;
      window.location.href = base + (params.length ? '?' + params.join('&') : '');
    });
  }

})();

/* ── Sticky header shadow detection ── */
(function() {
  var header = document.querySelector('.cl-subcats__header');
  if (!header) return;
  var sentinel = document.createElement('div');
  sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;visibility:hidden;';
  header.parentNode.insertBefore(sentinel, header);
  var observer = new IntersectionObserver(function(entries) {
    header.classList.toggle('is-stuck', !entries[0].isIntersecting);
  }, { threshold: 0 });
  observer.observe(sentinel);
})();

/* ── Active filter chips: render from URL params on page load ── */
(function() {
  var chipsContainer = document.querySelector('[data-active-filters]');
  var chipsContainerMobile = document.querySelector('[data-active-filters-mobile]');
  if (!chipsContainer && !chipsContainerMobile) return;

  /* Read server-rendered label map from data attribute */
  var labelData = {};
  var src = chipsContainer || chipsContainerMobile;
  try { labelData = JSON.parse((src.dataset.filterLabels || '{}')); } catch(e) {}

  var urlParams = new URLSearchParams(window.location.search);
  var chipXSvg = '<svg class="cl-filter-chip__x" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg>';

  urlParams.forEach(function(value, key) {
    /* Skip non-filter params */
    if (['page', 'sort_by', 'view', 'preview_theme_id', 'q'].indexOf(key) !== -1) return;

    var lookupKey = key + '|||' + value;
    var entry = labelData[lookupKey];
    var humanLabel = entry ? entry.label : decodeURIComponent(value);
    var groupName = entry ? entry.group : '';

    /* For price range, show formatted */
    if (key.indexOf('.gte') !== -1 || key.indexOf('.lte') !== -1) {
      groupName = 'Price';
      var _mfmt = document.body.getAttribute('data-money-format') || '${{amount}}';
      var _ac = parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
      humanLabel = (key.indexOf('.gte') !== -1 ? 'Min ' : 'Max ') + _mfmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, _ac).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(parseFloat(value)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(parseFloat(value)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount\s*\}\}/g, parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    var chipLabel = humanLabel;

    function makeChip() {
      var chip = document.createElement('button');
      chip.className = 'cl-filter-chip';
      chip.type = 'button';
      chip.setAttribute('aria-label', 'Remove filter: ' + chipLabel);
      chip.innerHTML = '<span>' + chipLabel + '</span>' + chipXSvg;
      chip.addEventListener('click', function() {
        var newParams = new URLSearchParams(window.location.search);
        var all = newParams.getAll(key);
        newParams.delete(key);
        all.forEach(function(v) {
          if (v !== value) newParams.append(key, v);
        });
        var newUrl = window.location.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
        window.location.href = newUrl;
      });
      return chip;
    }
    if (chipsContainer) chipsContainer.appendChild(makeChip());
    if (chipsContainerMobile) chipsContainerMobile.appendChild(makeChip());
  });
})();

/* ── Infinite scroll: load next page when trigger enters viewport ── */
(function() {
  var trigger = document.querySelector('[data-infinite-scroll]');
  if (!trigger) return;
  var grid = document.querySelector('[data-products-grid]');
  if (!grid) return;

  var loading = false;
  var nextUrl = trigger.dataset.nextUrl;

  var observer = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting || loading || !nextUrl) return;
    loading = true;

    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-products-grid]');
        var newTrigger = doc.querySelector('[data-infinite-scroll]');

        if (newGrid) {
          var items = newGrid.querySelectorAll('.cl-subcats__product-item');
          items.forEach(function(item) {
            grid.appendChild(item);
          });
        }

        if (newTrigger && newTrigger.dataset.nextUrl) {
          nextUrl = newTrigger.dataset.nextUrl;
        } else {
          nextUrl = null;
          trigger.hidden = true;
          observer.disconnect();
        }
        loading = false;
      })
      .catch(function() {
        loading = false;
        trigger.hidden = true;
      });
  }, { rootMargin: '400px' });

  observer.observe(trigger);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-video"] && !Shopify.designMode) return;
  try {
    
(function() {
  var player = document.querySelector('[data-video-player]');
  if (!player) return;

  var playBtn = player.querySelector('[data-video-play]');
  var nativeVideo = player.querySelector('[data-video-native]');
  var poster = player.querySelector('[data-video-poster]');
  var iframeWrap = player.querySelector('[data-video-iframe]');
  var controlsWrap = player.querySelector('[data-video-controls]');
  var progressWrap = player.querySelector('[data-video-progress]');
  var progressBar = player.querySelector('[data-video-progress-bar]');
  var muteBtn = player.querySelector('[data-video-mute]');
  var speedBtn = player.querySelector('[data-video-speed]');
  var fullscreenBtn = player.querySelector('[data-video-fullscreen]');
  var timeEl = player.querySelector('[data-video-time]');

  if (!playBtn) return;

  function fmtTime(s) {
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  /* Solution A: Local video */
  if (nativeVideo) {
    var isPlaying = false;
    var speeds = [1, 1.2, 1.5, 2];
    var speedIdx = 0;

    playBtn.addEventListener('click', function() {
      nativeVideo.play();
      nativeVideo.muted = false;
      playBtn.hidden = true;
      if (controlsWrap) controlsWrap.hidden = false;
      isPlaying = true;
    });

    nativeVideo.addEventListener('click', function() {
      if (isPlaying) {
        nativeVideo.pause();
        playBtn.hidden = false;
        isPlaying = false;
      } else {
        nativeVideo.play();
        playBtn.hidden = true;
        isPlaying = true;
      }
    });

    nativeVideo.addEventListener('timeupdate', function() {
      if (progressBar && nativeVideo.duration) {
        var pct = (nativeVideo.currentTime / nativeVideo.duration) * 100;
        progressBar.style.width = pct + '%';
      }
      if (timeEl && nativeVideo.duration) {
        timeEl.textContent = fmtTime(nativeVideo.currentTime) + ' / ' + fmtTime(nativeVideo.duration);
      }
    });

    nativeVideo.addEventListener('ended', function() {
      playBtn.hidden = false;
      if (controlsWrap) controlsWrap.hidden = true;
      isPlaying = false;
    });

    /* Progress bar seeking */
    if (progressWrap) {
      progressWrap.addEventListener('click', function(e) {
        if (!nativeVideo.duration) return;
        var rect = progressWrap.getBoundingClientRect();
        var pct = (e.clientX - rect.left) / rect.width;
        nativeVideo.currentTime = pct * nativeVideo.duration;
      });
    }

    /* Speed control */
    if (speedBtn) {
      speedBtn.addEventListener('click', function() {
        speedIdx = (speedIdx + 1) % speeds.length;
        nativeVideo.playbackRate = speeds[speedIdx];
        speedBtn.textContent = speeds[speedIdx] + 'x';
      });
    }

    /* Mute */
    if (muteBtn) {
      muteBtn.addEventListener('click', function() {
        nativeVideo.muted = !nativeVideo.muted;
        muteBtn.innerHTML = nativeVideo.muted
          ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>'
          : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>';
      });
    }

    /* Fullscreen */
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function() {
        if (nativeVideo.requestFullscreen) nativeVideo.requestFullscreen();
        else if (nativeVideo.webkitEnterFullscreen) nativeVideo.webkitEnterFullscreen();
      });
    }
    return;
  }

  /* Solution B: YouTube / Vimeo embed */
  if (iframeWrap) {
    function startEmbed() {
      var iframe = iframeWrap.querySelector('iframe');
      if (iframe && iframe.dataset.src) iframe.src = iframe.dataset.src;
      playBtn.hidden = true;
      if (poster) poster.hidden = true;
      iframeWrap.hidden = false;
    }
    playBtn.addEventListener('click', startEmbed);
    if (poster) poster.addEventListener('click', startEmbed);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-content"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Auto-generate TOC from H2 headings in legal body */
  var body = document.getElementById('legal-body');
  var tocNav = document.getElementById('legal-toc');
  if (!body || !tocNav) return;

  var headings = body.querySelectorAll('h2');
  if (headings.length === 0) {
    tocNav.style.display = 'none';
    return;
  }

  var title = document.createElement('p');
  title.className = 'legal-toc__title';
  title.textContent = 'Table of Contents';
  tocNav.appendChild(title);

  var list = document.createElement('ol');
  list.className = 'legal-toc__list';

  headings.forEach(function(h, i) {
    var id = 'section-' + (i + 1);
    h.id = id;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'legal-toc__link';
    a.href = '#' + id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });

  tocNav.appendChild(list);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function() {
  /* Copy link button */
  var copyBtn = document.querySelector('[data-share-copy]');
  if (!copyBtn) return;

  copyBtn.addEventListener('click', function() {
    var url = window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function() {
        showCopied();
      });
    } else {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showCopied();
    }
  });

  function showCopied() {
    var text = document.querySelector('[data-share-copy-text]');
    if (!text) return;
    var original = text.textContent;
    text.textContent = 'Copied!';
    setTimeout(function() { text.textContent = original; }, 2000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {
  var page = document.querySelector('[data-cart-page]');
  if (!page) return;

  /* ── Quantity +/- buttons ── */
  page.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var wrap = (minus || plus).closest('[data-qty-wrap]');
    var input = wrap.querySelector('[data-qty-input]');
    var val = parseInt(input.value, 10) || 1;

    if (minus) val = Math.max(1, val - 1);
    if (plus) val = Math.min(99, val + 1);

    input.value = val;
    updateQuantity(input.dataset.key, val);
  });

  /* ── Quantity input direct change ── */
  page.addEventListener('change', function(e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > 99) val = 99;
    input.value = val;
    updateQuantity(input.dataset.key, val);
  });

  /* ── Remove button ── */
  page.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    updateQuantity(btn.dataset.removeKey, 0);
  });

  function updateQuantity(key, qty) {
    var item = page.querySelector('[data-item-key="' + key + '"]');
    if (item) item.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      window.location.reload();
    })
    .catch(function() {
      if (item) item.classList.remove('is-updating');
    });
  }

  /* ── Order note save ── */
  var noteArea = page.querySelector('[data-order-note]');
  if (noteArea) {
    var noteTimer;
    noteArea.addEventListener('input', function() {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteArea.value })
        });
      }, 600);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-bundle-upsell"] && !Shopify.designMode) return;
  try {
    
(function() {
  var btn = document.querySelector('[data-bundle-add]');
  if (!btn) return;
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var vid = btn.dataset.variantId;
    if (!vid || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    var origHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:spin 0.6s linear infinite"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.innerHTML = origHTML;
      }, 2500);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.innerHTML = origHTML;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  const banner = document.querySelector('sale-banner');
  if (!banner) return;

  const sectionId = banner.dataset.sectionId;
  const storageKey = 'sale-banner-dismissed-' + sectionId;

  /* ── Dismiss logic ── */
  if (sessionStorage.getItem(storageKey)) {
    banner.hidden = true;
    return;
  }

  document.documentElement.classList.add('has-sale-banner');

  banner.querySelector('[data-sale-dismiss]').addEventListener('click', function () {
    banner.classList.add('sale-banner--closing');
    banner.addEventListener('animationend', function () {
      banner.hidden = true;
      document.documentElement.classList.remove('has-sale-banner');
    }, { once: true });
    sessionStorage.setItem(storageKey, '1');
  });

  /* ── Countdown timer ── */
  const endStr = banner.dataset.endDate;
  if (!endStr) return;

  const endDate = new Date(endStr);
  if (isNaN(endDate.getTime())) return;

  const daysEl    = banner.querySelector('[data-days]');
  const hoursEl   = banner.querySelector('[data-hours]');
  const minutesEl = banner.querySelector('[data-minutes]');
  const secondsEl = banner.querySelector('[data-seconds]');

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const now  = Date.now();
    const diff = endDate.getTime() - now;

    if (diff <= 0) {
      daysEl.textContent    = '00';
      hoursEl.textContent   = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';

      const headline = banner.querySelector('.sale-banner__headline');
      if (headline) headline.textContent = 'Sale Ended';

      const cta = banner.querySelector('.sale-banner__cta');
      if (cta) cta.style.display = 'none';

      return;
    }

    const totalSec = Math.floor(diff / 1000);
    const d = Math.floor(totalSec / 86400);
    const h = Math.floor((totalSec % 86400) / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;

    daysEl.textContent    = pad(d);
    hoursEl.textContent   = pad(h);
    minutesEl.textContent = pad(m);
    secondsEl.textContent = pad(s);

    requestAnimationFrame(function () {
      setTimeout(tick, 1000 - (Date.now() % 1000));
    });
  }

  tick();
})();

  } catch(e) { console.error(e); }
})();
})();
